import { Box } from '#core/components';
import {
  ChevronDownIcon,
  ChevronRightIcon,
  TagIcon
} from '#core/components/icons';
import type { TreeTag } from '#domains/tags';
import { useTagsStore } from '#domains/tags';

import styles from './TagRowIcon.module.css';

type TagIconProps = {
  tag: TreeTag;
};

const TagRowIcon = ({ tag }: TagIconProps) => {
  const setTreeTag = useTagsStore(state => state.setTreeTag);

  const handleChevronClick = (e: React.MouseEvent) => {
    e.preventDefault();
    setTreeTag({ type: 'TOGGLE_OPEN_STATE', payload: { tag } });
  };

  const ChevronIcon = tag.open ? ChevronDownIcon : ChevronRightIcon;

  if (!tag.hasChildren) {
    return <TagIcon className={styles.tagIcon} />;
  }

  return (
    <Box className={styles.iconWrapper}>
      <TagIcon className={styles.tagIcon} />
      <Box className={styles.chevron} onClick={handleChevronClick}>
        <ChevronIcon size={14} strokeWidth={2.3} />
      </Box>
    </Box>
  );
};

export default TagRowIcon;
